var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Auth } from 'aws-amplify';
import axios from 'axios';
import { logoutUser } from '../redux/actions';
import { store } from '../redux/store';
import { getItem as getLocalStorageItem } from './localStorage';
import { logger } from './logger';
var commonConfig = {
    headers: {
        // Accept: 'application/json',
        // 'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
    },
    timeout: Number(process.env.REACT_APP_API_TIMEOUT),
};
var http = axios.create(__assign({}, commonConfig));
http.interceptors.request.use(function (call) {
    logger.debug(call, 'Request try');
    return call;
}, function (error) {
    logger.error(error, 'Request catch');
    return Promise.reject(error);
});
http.interceptors.response.use(function (response) {
    logger.debug(response, 'Response try');
    return response.data;
}, function (error) {
    logger.error(error, 'Response catch');
    return Promise.reject(error);
});
var privateHttp = axios.create(__assign({}, commonConfig));
privateHttp.interceptors.request.use(function (call) { return __awaiter(void 0, void 0, void 0, function () {
    var token, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getLocalStorageItem('token');
                if (_a) return [3 /*break*/, 2];
                return [4 /*yield*/, Auth.currentSession()];
            case 1:
                _a = (_b.sent()).getIdToken().getJwtToken();
                _b.label = 2;
            case 2:
                token = _a;
                call.headers.Authorization = "Bearer ".concat(token);
                logger.debug(call, 'Request try');
                return [2 /*return*/, call];
        }
    });
}); }, function (error) {
    logger.error(error, 'Request catch');
    return Promise.reject(error);
});
privateHttp.interceptors.response.use(function (response) {
    logger.debug(response, 'Response try');
    return response.data;
}, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c;
    return __generator(this, function (_d) {
        // const originalRequest = error.config;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 422) {
            logger.debug(error, 'Response catch (422 - Expected in some cases)');
        }
        else {
            logger.error(error, 'Response catch');
        }
        if (((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
            store.dispatch(logoutUser());
            //@ts-ignore
            window.location = '/';
        }
        else if (((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 403) {
            //@ts-ignore
            window.location = '/';
        }
        else {
            return [2 /*return*/, Promise.reject(error)];
        }
        return [2 /*return*/];
    });
}); });
/**
 * Mesma autenticação do `privateHttp`, porém sem o redirect automático em 403.
 * Existem endpoints em que 403 é resposta esperada e precisa chegar ao caller
 * (ex.: GET /v2/process/{id}/resume quando o resumo ainda não foi gerado).
 * Nesses casos o redirect do `privateHttp` tiraria o usuário da tela.
 */
var privateHttpSilent = axios.create(__assign({}, commonConfig));
privateHttpSilent.interceptors.request.use(function (call) { return __awaiter(void 0, void 0, void 0, function () {
    var token, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getLocalStorageItem('token');
                if (_a) return [3 /*break*/, 2];
                return [4 /*yield*/, Auth.currentSession()];
            case 1:
                _a = (_b.sent()).getIdToken().getJwtToken();
                _b.label = 2;
            case 2:
                token = _a;
                call.headers.Authorization = "Bearer ".concat(token);
                return [2 /*return*/, call];
        }
    });
}); }, function (error) { return Promise.reject(error); });
privateHttpSilent.interceptors.response.use(function (response) { return response.data; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        // 401 continua deslogando: token inválido não é caso de negócio.
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            store.dispatch(logoutUser());
            //@ts-ignore
            window.location = '/';
        }
        return [2 /*return*/, Promise.reject(error)];
    });
}); });
export { http, privateHttp, privateHttpSilent };
